import {
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  closestCenter,
  MouseSensor,
  TouchSensor,
} from "@dnd-kit/core";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";

export function useCommonSensors() {
  const pointer = useSensor(PointerSensor, {
    activationConstraint: { distance: 6 }, // avoid accidental drags
  });

  const keyboard = useSensor(KeyboardSensor, {
    coordinateGetter: sortableKeyboardCoordinates,
  });

   const mouse =  useSensor(MouseSensor, {
      // Require the mouse to move by 10 pixels before activating
      activationConstraint: {
        distance: 6,
      },
    });
     const touch = useSensor(TouchSensor, {
      // Press delay of 250ms, with tolerance of 5px of movement
      activationConstraint: {
        distance: 6,
        delay: 250,
        tolerance: 5,
      },
    });

  return useSensors(pointer, keyboard, mouse, touch);
}

export const defaultCollisionDetection = closestCenter;
